import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { environment } from '@environments/environment';
import { SessionService } from './session.service';
import { PostcodeLookupService } from './postcode-lookup/postcode-lookup.service';

@Injectable()
export class LoqateService {
	private base_url: string = 'https://services.postcodeanywhere.co.uk/';
    private api_url: string = environment.api_url;

	constructor(
        private http_client: HttpClient, 
        private session_service: SessionService,
        private postcode_lookup_service: PostcodeLookupService
    ) {
        this.postcode_lookup_service.setProvider('loqate');
    }

	searchAddress(search_term: string): Observable<any> {
        return this.postcode_lookup_service.searchAddress(search_term);
	}

	getAddressById(id: string): Observable<any> {
        return this.postcode_lookup_service.getAddressById(id);
	}

	searchBank(search_account: string, search_sortcode: string): Observable<any> {
        const headers = new HttpHeaders({
            Domain: this.session_service.domain,
        });

        let params: HttpParams = new HttpParams();
		params = params.append('accountnumber', search_account);
		params = params.append('sortcode', search_sortcode);

        const url = new URL(`${this.api_url}core/postcode-lookup/search-bank/loqate`);
        const response = this.http_client.post(
            url.toString(),
            null,
            {
                headers: headers,
                params
            },
        );
        return response;
	}
}
